<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout.align-center(raw wrap)

                v-flex(xs12)

                    // Lnading page title field
                    v-text-field(
                        :error-messages="errors.collect('title')"
                        :data-vv-as="$t('fields.title')"
                        :label="$t('fields.landingPageTitle')"
                        name="title"
                        value="id"
                        v-model="model.title"
                        v-validate="'required|min:2|max:100'"
                        outline
                    )

                v-flex(xs12)
                    // Description textarea field
                    v-textarea(
                        name="description"
                        rows="4"
                        outline
                        v-model.lazy="model.description"
                        :data-vv-as="$t('fields.description')"
                        :label="$t('fields.description')"
                    )

                v-flex(xs12)

                    // Horizontal line
                    separator-component

                v-flex(xs12)

                    v-autocomplete(
                        :items="$t('selection.themesLandingPage')"
                        :label="$t('fields.themes')"
                        name="themes"
                        color="primary"
                        append-icon="expand_more"
                        deletable-chips
                        multiple
                        persistent-hint
                        small-chips
                        outline
                        return-object
                        item-text="title"
                        item-value="value"
                        v-model="model.themes"
                    )



                v-flex(xs12)

                    // Assign Meditations
                    v-autocomplete(
                        :error-messages="errors.collect('meditationIds')"
                        :items="sessions"
                        :search-input.sync="multiselectSearch"
                        :label="$t('fields.meditations')"
                        name="meditationIds"
                        color="primary"
                        append-icon="expand_more"
                        deletable-chips
                        multiple
                        persistent-hint
                        small-chips
                        outline
                        return-object
                        item-text="label"
                        item-value="id"
                        v-model="model.sessionIds"
                        v-validate="'required'"
                    )


                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ submitButtonText }}
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapGetters, mapActions } from 'vuex';
    import { sessions } from '~api';
    import Button from '~components/Button';
    import Separator from '~components/Separator';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        data() {
            return {
                multiselectSearch: null,
                sessions: []
            };
        },
        computed: {
            ...mapFields('landingPages', {
                model: 'landingPage'
            }),
            ...mapGetters('landingPages', ['isLoading']),
            isEditing() {
                return this.model.id;
            },
            submitButtonText() {
                return this.isEditing
                    ? this.$t('defaultButtons.update')
                    : this.$t('defaultButtons.save');
            }
        },
        async beforeMount() {
            const resp = await sessions.getAllForLandingPage();

            if (resp.ok) {
                this.sessions = resp.data.map(s => ({
                    ...s,
                    label: `${s.title} - ${s.instructor_fullName}`
                }));
            }
        },
        methods: {
            ...mapActions('landingPages', ['create', 'update', 'cancel']),
            /**
             * Validate fields on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return false;

                this.model.sessionsList = this.sessions.filter(session =>
                    this.model.sessionIds.includes(session.id)
                );

                return this.isEditing ? this.update() : this.create();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    >>> .v-select__selections
        overflow-x: auto
</style>
